import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { LeftComponentLabel, LogoutLeftNav, RightNavBalance, navBoxLHSArray } from './settingsCommon';
import { DOMAIN_ONSHIP, SETTINGS_DELETE_ACCOUNT_ICON, SETTINGS_PROFILE_ICON } from '../../utils/constants';
import { UserServiceClientApi } from '../../services/api/UserApiServices';
import { appType } from '../../utils/config/configHelpers';
import { logoutUser, setUserProfileImage } from '../../state/actions/user';
import { getAuthData } from '../../services/storage/LocalStorage';
import { clearLFStorage } from '../../services/storage/LFStorage';
import { useNavigate } from 'react-router-dom';
import { showToast } from '../../components/ui/toaster';
import { CircularProgress } from '@mui/material';
import { getUserProfileImageUrlThumbnail } from '../../utils/general';
import { useSocket } from '../../services/socket/socketContext';

import SelectNavBox from '../../components/common/SelectNavBox';
import StyledSaveButton from '../../components/common/StyledSaveButton';
import StyledCancelButton from '../../components/common/StyledCancelButton';
import ModalNewUI from '../../components/ui/Modals/ModalMessages/ModalNewUI';
import Avatar from '../../components/common/Avatar';
import DeleteAccountModal from '../../components/ui/Modals/DeleteAccountModal';
import LogoutModal from '../../components/ui/Modals/SettingsModals/LogoutModal';
import { setClearCacheForSpinnetBot } from '../../state/actions/bot';
import webSocketApiService from '../../services/socket/wsApiServices';


const AvatarForwarded = React.forwardRef((props, ref) => (
  <Avatar innerRef={ref} {...props} />
));

const SettingsLHS = ({ activeTab, setActiveTab, saveProfile, openRecharge, handleCancel, formEdited, showSpinner }) => {

  const selectedDomain = useSelector((state) => state.domain.selectedDomain)
  const sessionId = localStorage.getItem('sessionId');
  const userProfileImage = useSelector((state) => state.user.profileImage);
  const { userName, userId } = useSelector(state => state.user?.user) || ""
  const [showLogoutModal, setShowLogoutModal] = useState(false)
  const [showDeleteSpinner, setShowDeleteSpinner] = useState(false)
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { disconnectSocket } = useSocket();
  const navigate = useNavigate();


  useEffect(() => {
    if (!userProfileImage) return
    loadProfilePic()
  }, [userProfileImage])

  const loadProfilePic = (newPic = false) => {
    if (userProfileImage && !newPic) {
      setProfilePhoto(userProfileImage);
    } else {
      getUserProfileImageUrlThumbnail(userId)
        .then((file) => {
          setProfilePhoto(file);
          dispatch(setUserProfileImage(file));
        })
        .catch((error) => {
          setProfilePhoto(null);
        });
    }
  };

  const dispatch = useDispatch()

  const deleteUser = async () => {
    if (sessionId) {
      setShowDeleteSpinner(true)
      await webSocketApiService.DeleteUser({ appType: appType || '', sessionId })
        .then(response => {
          console.log("User deleted successfully", response)
          showToast("success", "User deleted successfully");
          handleLogout()
        })
        .catch(error => {
          console.error("Failed to delete user", error)
        })
        .finally(
          setShowDeleteSpinner(false)
        )
    }
  }

  const handleLogout = async (e) => {
    e?.preventDefault();
    const userId = getAuthData()?.user?.userId || null;
    dispatch(setClearCacheForSpinnetBot(false));
    if (userId) clearLFStorage();
    dispatch(setClearCacheForSpinnetBot(false));
    localStorage.removeItem("user");
    localStorage.removeItem("LoggedState");
    localStorage.removeItem("sessionId");
    localStorage.removeItem('scriptLoaded');

    disconnectSocket();
    dispatch(logoutUser());
    navigate("/");
  };

  return (
    <div className='settings-LHS-main'>

      <div className='settings-content'>
        <div>
          <div className='settings-avatar-and-heading'>
            <AvatarForwarded
              name={userName}
              imgSrc={profilePhoto || SETTINGS_PROFILE_ICON}
              size={91}
              height={91}
              color="name-avatar"
              style={{
                borderRadius: "50%",
                display: "flex",
                textAlign: "center",
                backgroundColor: profilePhoto ? "#e5743b" : 'transparent',
                justifyContent: "center",
                objectFit: "cover",
                marginTop: '4px',
                ...selectedDomain === DOMAIN_ONSHIP && { fontFamily: "Figtree-Regular" }
              }}
            />
            <h3 className={`settings-heading ${selectedDomain}_bold_font`}>Settings</h3>
          </div>

          <SelectNavBox
            leftNavComponent={<LeftComponentLabel label={"Balance"} />}
            rightNavComponent={<RightNavBalance />}
            customOnClickFn={openRecharge}
          />

          {
            navBoxLHSArray.map(item => {
              return (
                <SelectNavBox
                  key={item.label}
                  label={item.label}
                  isActive={activeTab === item.label}
                  setActiveTab={setActiveTab}
                />
              )
            })
          }

          <SelectNavBox
            leftNavComponent={<LogoutLeftNav />}
            rightNavComponent={<></>}
            customOnClickFn={() => setShowLogoutModal(true)}
          />

          {showLogoutModal &&
            <ModalNewUI open={showLogoutModal} headerContent={"Are you sure you want to logout"} onClose={() => setShowLogoutModal(false)}>
              <LogoutModal onConfirmFn={handleLogout} onCloseFn={() => setShowLogoutModal(false)} />
            </ModalNewUI>
          }

          <div className='settings-delete-account-container cursor-pointer'>
            <div onClick={() => setShowDeleteModal(true)} className='nav-box-label-error mr-2 cursor-pointer'>Delete account</div>
            <button className='settings-button-image' onClick={() => setShowDeleteModal(true)}>
              <img src={SETTINGS_DELETE_ACCOUNT_ICON} alt="deleteAccount" width="17px" />
            </button>
          </div>
        </div>

        <div className='settings-update-buttons'>
          <StyledCancelButton customWidth={180} custompadding="4px 25px" label="Cancel" onClickFn={handleCancel} />
          <StyledSaveButton disabled={!formEdited || showSpinner} custompadding="4px 25px" customWidth={180}
            label={
              showSpinner ? (
                <CircularProgress size='2vh' thickness={5} color='inherit' />
              ) : (
                "Save changes"
              )
            }
            onClickFn={saveProfile} />
        </div>
      </div>


      {showDeleteModal &&
        <ModalNewUI open={showDeleteModal} headerContent={"Are you sure you want to delete your Account"} onClose={() => setShowDeleteModal(false)}>
          <DeleteAccountModal onConfirmFn={deleteUser} onCloseFn={() => setShowDeleteModal(false)} showDeleteSpinner={showDeleteSpinner} />
        </ModalNewUI>
      }

    </div>
  )
}

export default SettingsLHS